const ServiceIcon = ({ width = 24, height = 24, color = '#000000' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.8125 16.8984V10.6484C19.8125 6.33371 16.3147 2.83594 12 2.83594V2.83594C7.68528 2.83594 4.1875 6.33371 4.1875 10.6484V16.8984"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M19.8125 11.4297V18.0673C19.8125 19.448 18.6932 20.5673 17.3125 20.5673H12"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M4.1875 12.2109H6.98059L8.25 13.5794V16.8984H4.1875V12.2109Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M19.8125 12.2109H17.0194L15.75 13.5794V16.8984H19.8125V12.2109Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M13.25 19.918H10.125V21.168H13.25V19.918Z"
        fill="#BBBBBD"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ServiceIcon
